<template>
  <div v-click-outside="closeDestinations" class="select-destination" @click.prevent.stop="">
    <div>
      <div class="bordered-input">
        <div :class="open?'destination-input focus':'destination-input'" @click.prevent.stop="toggleDestinations">
          <div class="destination-input__label">
            {{ label }}
          </div>
          <div v-if="open" class="icon caret-up" />
          <div v-else class="icon caret-down" />
        </div>
      </div>
    </div>
    <Transition v-show="open" name="slide-fade">
      <div v-show="open" class="destinations-popup">
        <div class="destinations-popup__destinations">
          <Destinations :instanceName="instanceName" />
        </div>
        <div class="controls">
          <div class="btn-underlined-dark-sm" @click.prevent.stop="clearDestinations">
            Clear
          </div>
          <div class="btn-primary-dark-sm" @click.prevent.stop="open = false">
            Ok
          </div>
        </div>
      </div>
    </Transition>
  </div>
</template>

<script>
import ClickOutside from 'vue-click-outside';
import Bus from '../../events/bus';
import cfg from '../../config/config';
import responsive from '../../mixins/responsive';
import Destinations from '../../pages/results/filters/Destinations.vue';

export default {
  name: 'MultipleDestinations',
  directives: {
    ClickOutside,
  },
  components: {
    Destinations,
  },
  mixins: [responsive],
  props: {
    searchVillaId: { type: Number, default: 1 },
    postionTop: { type: String, default: '71px' },
    postionTopMobile: { type: String, default: '70px' },
    instanceName: { type: String, default: '' },
  },
  data() {
    return {
      open: false,
      label: 'Destination',
      regionsSelected: [],
    };
  },
  computed: {
    position() {
      return {
        top: this.isMobile ? this.postionTopMobile : this.postionTop,
      };
    },
    allRegions() {
      return this.$store.getters['regions/allRegions'] ? this.$store.getters['regions/allRegions'].sort((a, b) => a.id - b.id) : null;
    },
    getDestinations() {
      return this.$store.getters['results/getDestinations'];
    },
    currentCollectionList() {
      return this.$store.getters['pages/getCollectionData'];
    },
    isResultsPage() {
      return this.$store.getters['pages/currentPage'] ? this.$store.getters['pages/currentPage'].templateId == 5 : false;
    },
    isFullHeight() {
      return this.$store.getters['pages/currentPage'] ? this.$store.getters['pages/currentPage'].templateId == 3 : false;
    },
    allDestinations: {
      get() {
        return this.$store.getters['results/getAllDestinations'].filter((x) => x.id !== 999 && x.id !== 5);
      },
      set(value) {
        this.$store.commit('results/setAllDestinations', value);
      },
    },
    urlHasFilters() {
      return this.$store.getters['filterbar/urlHasFilters'];
    },
  },
  watch: {
    allRegions() {
      this.initDestinations();
    },
    getDestinations(n, o) {
      this.updateDestinationsFromStore();
      this.updateLabels();
    },
  },
  mounted() {
    Bus.$on('closeSearchVillaTabs', this.closeTab);
    this.initDestinations();
    Bus.$emit('restoreFilterFromCookies');
  },
  beforeDestroy() {
    Bus.$off('closeSearchVillaTabs', this.closeTab);
  },
  methods: {
    initDestinations() {
      if (this.allRegions) {
        this.$store.dispatch('results/setupDestinations');
        this.restoreDestinations();
      }
    },
    toggleDestinations() {
      this.open = !this.open;
      if (this.open && this.isMobile && this.isFullHeight) {
        window.scrollTo({
          behavior: 'smooth',
          left: 0,
          top: 250,
        });
      }
      this.open ? Bus.$emit('closeSearchVillaTabs', this.searchVillaId) : null;
    },
    closeTab(id) {
      if (id != this.searchVillaId) {
        this.open = false;
      }
    },
    closeDestinations() {
      if (this.isDesktop) {
        this.open = false;
      }
    },
    onDestinationClicked(des) {
      des.selected = !des.selected;

      if (des.id === 999) {
        des.selected ? this.selectAllDestinations() : this.clearDestinations();
      }
      else {
        des.selected ? this.regionsSelected.push(des) : this.regionsSelected = this.regionsSelected.filter((x) => x.id !== des.id);
        // this.allDestinations[0].selected = this.regionsSelected.length === this.allDestinations.length -1;
        this.updateDestinationsSelected();
      }
    },
    selectAllDestinations() {
      this.allDestinations.forEach((x) => {
        x.selected = true;
      });
      // this.allDestinations[0].selected = true;
      this.regionsSelected = this.allDestinations.filter((x) => x.id !== 999);
      this.updateDestinationsSelected();
    },
    clearDestinations() {
      this.regionsSelected = [];
      this.allDestinations.forEach((x) => {
        x.selected = false;
        x.open = false;
      });
      Bus.$emit('clearCountries');
      // this.allDestinations[0].selected = false;
      this.updateDestinationsSelected();
    },
    updateDestinationsSelected() {
      const selectedIDs = this.regionsSelected.map((x) => x.id);
      if (!this.currentCollectionList) {
        window.$cookies.set('destinations', JSON.stringify(selectedIDs), cfg.neverExpire);
      }
      this.$store.commit('results/setDestinations', this.regionsSelected);
      this.isResultsPage ? this.filterProperties() : null;
    },
    updateLabels() {
      this.regionsSelected = this.allDestinations.filter((d) => !!d.selected && d.id !== 999);
      this.label = this.regionsSelected && this.regionsSelected.length > 0 ? `${this.regionsSelected.length} destinations` : 'Destination';
      if (this.regionsSelected && this.regionsSelected.length === 1) this.label = this.regionsSelected[0].name;
      // let labels = this.allDestinations.filter((d) => !!d.selected && d.id !== 999).map((x) => x.name).toString().replace(/[,]+/g, ', ');
      // labels = labels.length > 16 && !this.isMobile
      //   ? `${labels.slice(0, 16)}...`
      //   : labels.length > 28 && this.isMobile ? `${labels.slice(0, 28)}...` : labels;
      // this.allDestinations[0].selected = this.regionsSelected.length === this.allRegions.length;
      // this.label = this.regionsSelected.length === this.allDestinations.length || this.regionsSelected.length === 0 ? 'Destination' : labels;
    },

    restoreDestinations() {
      const destinationsCookie = JSON.parse(window.$cookies.get('destinations'));
      this.allDestinations.forEach((x) => x.selected = false);

      // Restore destinations from Store
      if (this.getDestinations.length > 0) {
        this.updateDestinationsFromStore();
      }
      // restore desinations from cookies
      else if (!this.urlHasFilters && destinationsCookie && destinationsCookie.length > 0) {
        this.regionsSelected = this.allDestinations.filter((x) => destinationsCookie.includes(x.id));
        this.regionsSelected.forEach((x) => x.selected = true);
        this.$store.commit('results/setDestinations', this.regionsSelected);
      }
      else
      {
        this.allDestinations.forEach((x) => x.selected = false);
      }

      this.updateLabels();
    },
    updateDestinationsFromStore() {
      this.allDestinations.forEach((x) => x.selected = false);
      this.regionsSelected = this.allDestinations.filter((x) => this.getDestinations.map((r) => Number(r.id)).includes(x.id));
      this.regionsSelected.forEach((x) => x.selected = true);
    },
    filterProperties() {
      gsap.delayedCall(0.1, this.filterPropertiesLocally);
    },
    filterPropertiesLocally() {
      this.currentCollectionList
        ? this.$store.dispatch('results/fetchProperties', { query: this.$route.query })
        : this.$store.dispatch('results/filterPropertiesLocally');
    },

  },
};
</script>

<style lang="scss" scoped>
@import "../../assets/styles/settings/config.scss";

.select-destination {
  position: relative;
}

.select-destination-input{
    max-width: 170px;
}

  .destination-input {
    position: relative;
    /*border: 1px solid $solitude;*/
    /*border-radius: 8px;*/
    height: 70px;
    background-color: $limeStone;
    padding: 0 24px;
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: space-between;
    cursor: pointer;

    &.focus {
      background-color: $stoneCream;
    }

    .mobile-search-villa__container & {
      background-color: $stoneWhite;

      &.focus {
        background-color: $stoneWhite;
      }
    }

    div {
      display: inline-block;
      cursor: pointer;
    }

    &__label {
      text-align: left;
      font-size: 16px;
      color: $darkBlack;
    }

    &__icon {
      margin: 0 10px;
      text-align: right;
    }
  }

.icon {
  cursor: pointer;

  &.caret-up {
    background-image: url(../../assets/img/src/icons/chevron-up.svg);
    background-size: 13px 13px;
    width: 13px;
    height: 13px;
  }

  &.caret-down {
    background-image: url(../../assets/img/src/icons/chevron-down.svg);
    background-size: 13px 13px;
    width: 13px;
    height: 13px;
  }
}

.destinations-popup {
  position: absolute;
  left: -1px;
  background-color: $limeStone;
  border: 1px solid $stoneLight;
  z-index: 110;
  overflow: hidden scroll;
  width: 100%;
  min-width: 275px;
  height: auto;
  max-height: 45vh;

  &__destinations {
    position: relative;
    padding: 0 20px;
  }

  .search-villa--sticky & {
    bottom: 71px;
  }

  @include mobile {
    width: 100%;
    margin: 0 4px;
  }

  .mobile-search-villa__container & {
    margin: 8px 0 0 0;
    background: $stoneWhite;
    border: 1px solid $yellowStone;
    right: 0;
  }
}

.destination-group{
    margin:20px 0;
}

.destination-label{
    color: $darkBlack;
    font-family: $font-family-grotesk;
    font-size: 16px;
    font-stretch: normal;
    font-style: normal;
    letter-spacing: normal;
    text-align: left;
}

.controls {
  position: sticky;
  bottom: 0;
  left: 0;
  padding: 5px 0;
  width: 100%;
  display: grid;
  grid-column-gap: auto;
  grid-row-gap: 0px;
  grid-template-columns: 40% 40%;
  justify-content: space-around;
  background-color: $limeStone;
   .btn-underlined-dark-sm {
    display: flex;
    align-items: center;
    justify-content: center;
   }
}

</style>
